export default (key, value, page) => {
  let searchParams = new URL(location.href).searchParams;
  if (key === undefined && page === "services") {
    key = "sub_page";
    if (searchParams.toString().includes("seo")) {
      value = "ppc";
    } else {
      value = "seo";
    }
  }
  searchParams.set(key, value);
  searchParams = "?" + searchParams.toString();
  var newurl = `${window.location.origin}${window.location.pathname}${searchParams}`;
  window.history.pushState({ path: newurl }, "", newurl);
};
